const formatConfiguration = (feature, properties) =>
    properties.reduce((acc, val) => {
        // TODO: ROLLBACK AND DISPATCH A NEW ACTION IN LANGUAGE CONTEXT
        if (val.id === 'search_terms') {
            return {
                ...acc,
                [val.id]: val,
            }
        }
        return {
            ...acc,
            [val.id]: val.current_value !== undefined ? val.current_value : val.default_value,
        }
    }, {})

const parseConfiguration = configuration => {
    const configurationResponse = configuration.configurations
    // Validating the API response and formatting it
    const configurationProperties =
        configurationResponse &&
        Array.isArray(configurationResponse) &&
        configurationResponse.map(({ feature, properties }) =>
            formatConfiguration(feature, properties)
        )
    const parsedConfiguration = configurationProperties.reduce((acc, val) => ({ ...acc, ...val }))
    return parsedConfiguration
}

export default parseConfiguration
